import { useDispatch, useSelector } from 'react-redux';
import { includeDishes as includeDishesAction } from '../actions';
import { getIsIncluding, getIncludeError } from '../selectors';

/**
 * Includes dishes making the appear in the New (Global) Dishes views.
 *
 * @returns {[includeDishes, *, *]}
 */
const useIncludeDishes = () => {
  const dispatch = useDispatch();
  const isIncluding = useSelector(getIsIncluding);
  const includeError = useSelector(getIncludeError);

  const includeDishes = (formulaCodes = []) => {
    if (formulaCodes.length === 0) {
      return;
    }
    dispatch(includeDishesAction(formulaCodes));
  };

  return [includeDishes, isIncluding, includeError];
};

export default useIncludeDishes;
